// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--HZGrG";
export var content = "styles-module--content--PTyCc";
export var title = "styles-module--title--UlfcT";
export var subtitle = "styles-module--subtitle--d9Tmy";
export var intro = "styles-module--intro--PRUzM";
export var cta = "styles-module--cta--KHuIH";
export var scrolldown = "styles-module--scrolldown--ywKy+";
export var extra = "styles-module--extra--HssY0";